import { formatBloodPressureChartLabel, todayIsoDate } from './fitnessProfileBloodPressure';

export { todayIsoDate };

export function apiWeightsToTrend(readings = []) {
	return readings.map((reading) => {
		const date =
			reading.recorded_on ||
			(typeof reading.recorded_at === 'string' ? reading.recorded_at.slice(0, 10) : '');
		const value = Number(reading.pounds);
		return {
			date,
			value,
			month: formatBloodPressureChartLabel({ date })
		};
	});
}

export function latestWeightDisplay(trend) {
	if (!trend?.length) return null;
	const last = trend[trend.length - 1];
	if (!Number.isFinite(last.value)) return null;
	return last.value === Math.round(last.value) ? `${Math.round(last.value)} lbs` : `${last.value} lbs`;
}

export function weightFormFromReading(reading) {
	const date =
		reading?.recorded_on ||
		(typeof reading?.recorded_at === 'string' ? reading.recorded_at.slice(0, 10) : '') ||
		todayIsoDate();
	const pounds = reading?.pounds;
	return {
		date,
		pounds: pounds == null ? '' : String(pounds),
		editingId: reading?.id ?? null
	};
}

export function validateWeightInput(poundsRaw) {
	const pounds = Number.parseFloat(String(poundsRaw).trim());
	if (!Number.isFinite(pounds) || pounds <= 0) {
		return { valid: false, error: 'Enter a valid weight in pounds.' };
	}
	if (pounds < 50 || pounds > 600) {
		return { valid: false, error: 'Weight should be between 50 and 600 lbs.' };
	}
	return { valid: true, pounds: Math.round(pounds * 10) / 10 };
}
